import { NgModule } from '@angular/core';
import { DateFormatPipe, DateTimeFormatPipe, TimeFormatPipe } from '../pipes/date-format-pipe';
import { CountryPipe } from '../pipes/country-pipe';
import { CurrencyDisplayNamePipe, CurrencyPipe, CurrencyTextPipe, NumberFormatter } from '../pipes/currency-pipe';

@NgModule({
  declarations: [CountryPipe, DateFormatPipe, DateTimeFormatPipe, TimeFormatPipe, CurrencyPipe, NumberFormatter , CurrencyTextPipe, CurrencyDisplayNamePipe],
  imports: [],
  exports: [CountryPipe, DateFormatPipe, DateTimeFormatPipe, TimeFormatPipe, CurrencyPipe, NumberFormatter, CurrencyTextPipe, CurrencyDisplayNamePipe]
})
export class SharedPipesModule {}



// WEBPACK FOOTER //
// ./src/shared/shared-pipes.module.ts